import { render } from "./ActionComponent.vue?vue&type=template&id=50d8de34"
import script from "./ActionComponent.vue?vue&type=script&lang=js"
export * from "./ActionComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__